import * as React from 'react'
import {
  CanvasEngine,
  TransformLayerWidget,
  LayerModel
} from '@projectstorm/react-canvas-core'

export interface SmartLayerWidgetProps {
  readonly layer: LayerModel
  readonly engine: CanvasEngine
}

export class SmartLayerWidget extends React.Component<SmartLayerWidgetProps> {
  public render() {
    const { engine, layer } = this.props

    return engine
      .getFactoryForLayer(layer)
      .generateReactWidget({ model: layer })
  }
}

export interface DiagramProps {
  readonly engine: CanvasEngine
  readonly className?: string
}

export class CustomCanvasWidget extends React.Component<DiagramProps> {
  private ref: React.RefObject<HTMLDivElement>

  constructor(props: DiagramProps) {
    super(props)

    this.ref = React.createRef()
  }

  public componentWillUnmount() {
    const { engine } = this.props
    engine.setCanvas(undefined)
  }

  public componentDidMount() {
    this.registerCanvas()
  }

  public componentDidUpdate() {
    this.registerCanvas()
  }

  public render() {
    const { engine, className } = this.props
    const model = engine.getModel()

    return (
      <div className={className} ref={this.ref}>
        {model.getLayers().map((layer, index) => {
          return (
            <TransformLayerWidget key={index} layer={layer}>
              <SmartLayerWidget
                layer={layer}
                engine={engine}
                key={layer.getID()}
              />
            </TransformLayerWidget>
          )
        })}
      </div>
    )
  }

  private registerCanvas() {
    const { engine } = this.props
    engine.setCanvas(this.ref.current ? this.ref.current : undefined)
  }
}
